import { DownloadFile, enqueueSnackbar, UploadFile } from 'actions';
import {
	GetSitesOptIncidentsRequest,
	GetSiteOptIncidentDetailsRequest,
	GetSiteOptIncidentDropdownsRequest,
	EditSiteOptIncidentDetailsRequest,
	CreateSiteOptIncidentRequest,
	DeleteSiteOptIncidentRequest,
	ExportSitesOptIncidentsRequest,
	GetAutocompleteFieldsRequest,
	GetDriveTestsCitiesRequest,
	GetDriveTestsDrivesRequest,
	GetDriveTestsDatesRequest,
	GetFailuresRequest,
	AddAttachmentRequest,
	DownloadAttachmentRequest,
	RemoveAttachmentRequest
} from '../requests/SiteOptRequests';

export const SET_FORM_STATE = 'SET_FORM_STATE';
export const RESET_FIELDS = 'RESET_FIELDS';
export const GET_OPT_SITE_TRACKER = 'GET_OPT_SITE_TRACKER';
export const TOGGLE_OPT_SITE_DIALOG = 'TOGGLE_OPT_SITE_DIALOG';
export const GET_OPT_SITE_TRACKER_DETAILS = 'GET_OPT_SITE_TRACKER_DETAILS';
export const GET_OPT_SITE_TRACKER_DROPDOWNS = 'GET_OPT_SITE_TRACKER_DROPDOWNS';
export const TOGGLE_DELETE_OPT_SITE_DIALOG = 'TOGGLE_DELETE_OPT_SITE_DIALOG';
export const GET_OPT_SITE_AUTOCOMPLETE = 'GET_OPT_SITE_AUTOCOMPLETE';
export const GET_DRIVETESTS_CITIES = 'GET_DRIVETESTS_CITIES';
export const GET_DRIVETESTS_DRIVES = 'GET_DRIVETESTS_DRIVES';
export const GET_DRIVETESTS_DATES = 'GET_DRIVETESTS_DATES';
export const SET_SELECTED_DATES = 'SET_SELECTED_DATES';
export const GET_FAILURES = 'GET_FAILURES';
export const SET_SELECTED_FAILURES = 'SET_SELECTED_FAILURES';
export const TOGGLE_ATTACH_FILE_OPT_SITE_DIALOG = 'TOGGLE_ATTACH_FILE_OPT_SITE_DIALOG';
export const TOGGLE_REMOVE_FILE_OPT_SITE_DIALOG = 'TOGGLE_REMOVE_FILE_OPT_SITE_DIALOG';

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

const onResetFields = () => ({
	type: RESET_FIELDS,
});

const onGetSitesOptIncidents = (value) => ({
	type: GET_OPT_SITE_TRACKER,
	incidents: value
});

const onToggleSiteOptDialog = (visible, tableId) => ({
	type: TOGGLE_OPT_SITE_DIALOG,
	visible,
	tableId
});

const onGetSiteOptIncidentDetails = (value) => ({
	type: GET_OPT_SITE_TRACKER_DETAILS,
	incidentDetails: value
});

const onGetSiteOptIncidentDropdowns = (value) => ({
	type: GET_OPT_SITE_TRACKER_DROPDOWNS,
	dropdowns: value
});

const onToggleDeleteSiteOptDialog = (visible, tableId) => ({
	type: TOGGLE_DELETE_OPT_SITE_DIALOG,
	visible,
	tableId
});

const onGetAutocompleteFields = (value) => ({
	type: GET_OPT_SITE_AUTOCOMPLETE,
	autocompleteFields: value
});

const onGetDriveTestsCities = (value) => ({
	type: GET_DRIVETESTS_CITIES,
	cities: value
});

const onGetDriveTestsDrives = (value) => ({
	type: GET_DRIVETESTS_DRIVES,
	drives: value
});

const onGetDriveTestsDates = (value) => ({
	type: GET_DRIVETESTS_DATES,
	dates: value
});

const onSetSelectedDates = (value) => ({
	type: SET_SELECTED_DATES,
	selectedDates: value
});

const onGetFailures = (value) => ({
	type: GET_FAILURES,
	failures: value
});

const onSetSelectedFailures = (value) => ({
	type: SET_SELECTED_FAILURES,
	selectedFailures: value
});

const onToggleAttachFileSiteOptDialog = (visible) => ({
	type: TOGGLE_ATTACH_FILE_OPT_SITE_DIALOG,
	visible
});

const onToggleRemoveFileSiteOptDialog = (visible) => ({
	type: TOGGLE_REMOVE_FILE_OPT_SITE_DIALOG,
	visible
});

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

export const ResetFields = () => (dispatch) => {
	dispatch(onResetFields());
};

export const GetSitesOptIncidents = (userId, role) => async (dispatch) => {
	await GetSitesOptIncidentsRequest(userId, role).then(response => {
		dispatch(onGetSitesOptIncidents(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ToggleSiteOptDialog = (visible, tableId) => (dispatch) => {
	dispatch(onToggleSiteOptDialog(visible, tableId));
};

export const GetSiteOptIncidentDetails = (userId, tableId) => async (dispatch) => {
	await GetSiteOptIncidentDetailsRequest(userId, tableId).then(response => {
		dispatch(onGetSiteOptIncidentDetails(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetSiteOptIncidentDropdowns = (userId, tableId) => async (dispatch) => {
	await GetSiteOptIncidentDropdownsRequest(userId, tableId).then(response => {
		dispatch(onGetSiteOptIncidentDropdowns(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const EditSiteOptIncidentDetails = (siteOptimizationsDto) => async (dispatch) => {
	await EditSiteOptIncidentDetailsRequest(siteOptimizationsDto).then(response => {
		dispatch(GetSitesOptIncidents());
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const CreateSiteOptIncident = (siteOptimizationsDto) => async (dispatch) => {
	await CreateSiteOptIncidentRequest(siteOptimizationsDto).then(response => {
		dispatch(GetSitesOptIncidents());
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ToggleDeleteSiteOptDialog = (visible, tableId) => (dispatch) => {
	dispatch(onToggleDeleteSiteOptDialog(visible, tableId));
};

export const DeleteSiteOptIncident = (userId, tableId) => async (dispatch) => {
	await DeleteSiteOptIncidentRequest(userId, tableId).then(response => {
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ExportSitesOptIncidents = (userId, role) => async (dispatch) => {
	await ExportSitesOptIncidentsRequest(userId, role).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetAutocompleteFields = (siteId) => async (dispatch) => {
	await GetAutocompleteFieldsRequest(siteId).then(response => {
		dispatch(onGetAutocompleteFields(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestsCities = () => async (dispatch) => {
	await GetDriveTestsCitiesRequest().then(response => {
		dispatch(onGetDriveTestsCities(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestsDrives = (city) => async (dispatch) => {
	await GetDriveTestsDrivesRequest(city).then(response => {
		dispatch(onGetDriveTestsDrives(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestsDates = (city, drive) => async (dispatch) => {
	await GetDriveTestsDatesRequest(city, drive).then(response => {
		dispatch(onGetDriveTestsDates(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const SetSelectedDates = (selectedDates) => (dispatch) => {
	dispatch(onSetSelectedDates(selectedDates));
};

export const GetFailures = (selectedCity, selectedDates) => async (dispatch) => {
	await GetFailuresRequest(selectedCity, selectedDates).then(response => {
		dispatch(onGetFailures(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const SetSelectedFailures = (selectedFailures) => (dispatch) => {
	dispatch(onSetSelectedFailures(selectedFailures));
};

export const AddAttachment = (userId, incidentId, filePath) => async (dispatch) => {
	await AddAttachmentRequest(userId, incidentId, filePath).then(response => {
		// dispatch(GetRepositoryFiles());
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const UploadAttachment = (userId, incidentId, file) => async (dispatch) => {
	await UploadFile(file).then(response => {
		dispatch(AddAttachment(userId, incidentId, response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ToggleAttachFileSiteOptDialog = (visible) => (dispatch) => {
	dispatch(onToggleAttachFileSiteOptDialog(visible));
};

export const DownloadAttachment = (userId, tableId) => async (dispatch) => {
	await DownloadAttachmentRequest(userId, tableId).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ToggleRemoveFileSiteOptDialog = (visible) => (dispatch) => {
	dispatch(onToggleRemoveFileSiteOptDialog(visible));
};

export const RemoveAttachment = (userId, tableId) => async (dispatch) => {
	await RemoveAttachmentRequest(userId, tableId).then(response => {
		// dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
